export enum OperationHistoryEsEnum {
    PTITIOS = "CASES_MENU_TAB",
    DASHBOARD = "SUMMARY_MENU_TAB",
    EMAIL = "LOCATIONPAGE_EDIT_EMAIL",
    MOBILE = "LOCATIONPAGE_EDIT_PHONE",
    PHONE = "LOCATIONPAGE_EDIT_DESK_PHONE",
    USER = "PROFILE_TAB",
    PETICIONES_CREATE = "PETICIONES_CREATE",
    PETICIONES_ABANDON_STEP1 = "PETICIONES_ABANDON_STEP1",
    PETICIONES_ABANDON_STEP2 = "PETICIONES_ABANDON_STEP2",
    ENVIAR_SOLICITUD_ERROR = "ENVIAR_SOLICITUD_ERROR",
    DESCARGAR_DOCUMENTOS_ERROR = "DESCARGAR_DOCUMENTOS_ERROR",
    STAGE_TECHNICALVERIFICATION = "STAGE_TECHNICALVERIFICATION",
    STAGE_SOLARINSTALLATION = "STAGE_SOLARINSTALLATION",
    STAGE_REGISTER = "STAGE_REGISTER",
}
